import ruko1 from "./Screenshot_4.webp";
import ruko2 from "./Screenshot_2-2.webp";
import ruko3 from "./Screenshot_3-1.webp";
import ruko4 from "./Screenshot_1-3.webp";
import ruko5 from "./Screenshot_5-1.webp";

const rukoimg = [ruko1, ruko2, ruko3, ruko4, ruko5];

export default rukoimg;
